import Modal from 'react-modal';
import  { useState, useEffect } from 'react';
import axios from 'axios';


const CancelEventClientModal = ({ isOpen, closeModal, businessId}) => {

  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");

  useEffect(() => {
    const fetchBusinessContact = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/businessInfo/${businessId}`,
          { withCredentials: true }
        );

        console.log("Business contact data:", res.data);
        setPhone(res?.data.data.business.phone);
        setEmail(res?.data.data.business.email);
        
      } catch (error) {
        console.error("Error fetching profile image:", error);
      }
    };

    if (businessId) {
      fetchBusinessContact();
    }
  }, [businessId]);

  return (
    <>
      <Modal
        isOpen={isOpen}
        onRequestClose={closeModal}
        className="modal-content"
        style={{
          content: {
            width: '570px',
            height: '250px',
            margin: 'auto',
            padding: '30px',
          },
        }}
      >
        <span className="close" onClick={closeModal}>&times;</span>
        <h2 className="modal-title">Cancel or Reschedule Your Event</h2>
        <p style={{ fontSize: '15px', color: '#625C73' }}>
          If you need to cancel your photobooth booking, please contact the vendor directly as soon as possible. By contacting, you’ll be able to confirm the cancellation and discuss any potential cancellation fees or rescheduling options.
        </p>

        <div style={{ marginTop: '20px', color: '#625C73', fontSize: '15px' }}>
  <ul style={{ listStyleType: 'disc', paddingLeft: '20px', lineHeight: '1.8' }}>
    {phone && (
      <li>
        <strong style={{ color: '#2A1980' }}>Phone:</strong> {phone}
      </li>
    )}
    
    {email && (
      <li>
        <strong style={{ color: '#2A1980' }}>Email:</strong> {email}
      </li>
    )}

    {/* You can easily add more business details here later! */}
    {/* {website && <li><strong style={{ color: '#2A1980' }}>Website:</strong> {website}</li>} */}
  </ul>
</div>

      
      </Modal>

     
    </>
  );
};

export default CancelEventClientModal;
